import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-asterisks',
  templateUrl: './asterisks.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./asterisks.component.less']
})
export class AsterisksComponent implements OnInit {
  @Input() asterisks!: string[];

  constructor() {
  }

  ngOnInit(): void { }

}
